/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {formatMoney, openNotice} from '../../utils/index.js';
import {getOwning, fetchChannelList, idDelete, getOrderDetails} from '../../service/order';
import moment from 'moment';
import {Store, Actions} from './store';
import {objectSerial, config} from 'Utils';
import {getGouXiaoUnitList} from "../../service/traceOrder";

class SearchOwning extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.channelName = this.props.location.query.channelName || '';
        this.customerManagementId = this.props.location.query.customerManagementId ? parseInt(this.props.location.query.customerManagementId, 10) : '';
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['欠货管理'],
            key: 0,
            rows: [],
            total: 1,
            searchObj: {
                BOOKED_DATE: '',
                DESCRIPTION: '',
                ORDER_NUMBER: '',
                orderedDateBegin: '',
                orderedDateEnd: '',
                salesChannelCode: '',
                all_sum_price: 0,
                comments: '',
                terminalName: '',
                s: 10,
                p: 1,
            },
            channel_type: [], /* 渠道类型 */
            regionOptions: [], /* 所属区域 */
            loading: false,
            userData: JSON.parse(window.localStorage.getItem('login_user_information') || '{}') || ''
        };
        this.exportChange = this.exportChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    goView(url) {
        hashHistory.push(url);
    }

    /*导出*/
    exportChange() {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/orderReport/oweGoodsExportExcel?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    /*列表操作*/

    /*审核*/
    auditRecord(index) {
        console.log('audit' + index);
    }

    /*确认收货*/
    confirmRecord(index) {
        console.log('confirm' + index);
    }

    /*评价*/
    evaluationRecord(record) {
        hashHistory.push('order/evaluate/' + record.orderId + '/' + record.id);
    }

    /*编辑*/
    editRecord(record, index) {
        if (record.orderType == '1') {
            this.goView(`order/addConventional1/${9}&${record.id}`);
        }
        if (record.orderType == '2') {
            this.goView(`order/addProject1/${9}&${record.id}`);
        }
        if (record.orderType == '3') {
            this.goView(`order/addPartners1/${9}&${record.id}`);
        }
    }

    /*删除*/
    deleteRecord(index) {
        // console.log('delet' + index);
        idDelete(this.state.rows[index].id).then(result => {
            if (result.code == 200) {
                openNotice('success', '删除成功', '');
                this.initData();

            }

        })
    }

    /*筛选重置*/
    advanceReset() {
        let self = this;
        this.setState({
            key: 0,
            searchObj: {
                ...this.state.searchObj,

                BOOKED_DATE: '',
                DESCRIPTION: '',
                ORDER_NUMBER: '',
                orderedDateBegin: '',
                orderedDateEnd: '',
                comments: '',
                p: 1,
                salesChannelCode: '',
                terminalName: ''
            }
        }, function () {
            self.initData();
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        // if (!this.state.searchObj.orderedDateBegin || this.state.searchObj.orderedDateBegin == '') {
        //     openNotice('warning', '请选择日期范围后再做查询');
        //     return;
        // }
        // if (!this.state.searchObj.orderedDateEnd || this.state.searchObj.orderedDateEnd == '') {
        //     openNotice('warning', '请选择日期范围后再做查询');
        //     return;
        // }
        this.setState({
            key: this.state.searchObj.orderStatus,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'BOOKED_DATE') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderedDateBegin: value.from,
                    orderedDateEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*翻页*/
    pageChange(page, s) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = this.state.searchObj;
        self.setState({
            loading: true
        })
        searchObj.orderStatus = searchObj.orderStatus == 0 ? '' : searchObj.orderStatus;
        getOwning(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'all_sum_price': result.data[0] ? result.data[0]['ALL_SUM_PRICE'] : 0,
                    'total': result.total,
                    'loading': false
                });
            } else {
                openNotice('error', '数据获取失败', '');
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'order') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.orderStatus
            });
        }
    }

    componentDidMount() {
        let self = this;
        //this.initData();
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            var a = {...res};
            if (res.status) {
                let arr = [];
                a.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        let channelCode = window.sessionStorage.getItem('cur_channelId');
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                this.setState({gouxiaoUnitList: arr})
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    /*返回*/
    backTo() {
        window.history.go(-1);
    }

    render() {
        const {
            opts,
            key,
            rows,
            total,
            searchObj,
            channel_type,
            loading,
            all_sum_price,
            gouxiaoUnitList,
            userData
        } = this.state;
        const advanceProps = {
            fileds: [
                // {
                //     name: 'code',
                //     label: '订单编码',
                //     text: '输入订单编码',
                //     type: 'default',
                //     defaultValue: searchObj.code
                // },
                // {
                //     name: 'productCode',
                //     label: '物料编号',
                //     text: '输入物料编号',
                //     type: 'default',
                //     defaultValue: searchObj.productCode
                // },
                // {
                //     name: 'orderStatus',
                //     label: '订单状态',
                //     text: '选择订单状态',
                //     options: [
                //         { value: '', text: '全部' },
                //         { value: '1', text: '暂存' },
                //         { value: '2', text: '待客户确认' },
                //         { value: '3', text: '已提交' },
                //         { value: '4', text: '已驳回' },
                //         { value: '5', text: '驳回后提交' },
                //         { value: '6', text: '待收货' },
                //         { value: '7', text: '已完成' },
                //         { value: '8', text: '客户已驳回' },
                //         { value: '9', text: '已确认' },
                //         { value: '10', text: '大客户已确认' },
                //     ],
                //     multiple: false,//支持多选
                //     type: 'select',
                //     defaultValue: searchObj.orderStatus || ''
                // },
                // {
                //     name: 'orderType',
                //     label: '订单类型',
                //     text: '选择订单类型',
                //     options: [
                //         { value: '', text: '全部' },
                //         { value: '1', text: '常规订单' },
                //         { value: '2', text: '项目订单' },
                //         { value: '3', text: '合作伙伴订单' },
                //     ],
                //     multiple: false,//支持多选
                //     type: 'select',
                // },
                // {
                //     name: 'gatherRealityAddress',
                //     label: '实际收货地址',
                //     text: '输入实际收货地址',
                //     type: 'default',
                //     defaultValue: searchObj.gatherRealityAddress
                // },

                {
                    name: 'BOOKED_DATE',//orderedDateBegin, orderedDateEnd
                    label: '日期查询',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderedDateBegin || '',
                        end: searchObj.orderedDateEnd || ''
                    },
                },
                {
                    name: 'orderNumber',
                    label: '订单编号',
                    text: '输入订单编号',
                    type: 'default',
                    defaultValue: searchObj.ORDER_NUMBER
                },
                {
                    name: 'itemDesc',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.DESCRIPTION
                },
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '输入购货单位',
                    type: 'select',
                    defaultValue: searchObj.salesUnitId,
                    showSearch: true,
                    options: gouxiaoUnitList,
                },
                {
                    name: 'salesChannelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.channel
                },
                {
                    name: 'comments',
                    label: '头备注',
                    text: '输入头备注',
                    type: 'default',
                    defaultValue: searchObj.comments
                }
                ,
                {
                    name: 'terminalName',
                    label: '终端单位',
                    text: '输入终端单位',
                    type: 'default',
                    defaultValue: searchObj.terminalName
                }

            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                // {
                //   title: '要货单号',
                //   dataIndex: 'getProCode',
                //   render: (text, record, index) => {
                //       if (record.orderType == "1") {
                //           if (record.orderStatus == '1') {
                //             return <a href={`#/order/${record.id}/conventionalDetail1/${record.code}/${record.orderStatus}`}>{text}</a>;
                //           } else {
                //             return <a href={`#/order/${record.id}/conventionalDetail/${record.code}`}>{text}</a>;
                //           }
                //       }
                //       if (record.orderType == "2") {
                //         if (record.orderStatus == '1') {
                //             return <a href={`#/order/${record.id}/projectDetail1/${record.code}/${record.orderStatus}`}>{text}</a>;
                //           } else {
                //             return <a href={`#/order/${record.id}/projectDetail/${record.code}`}>{text}</a>;
                //           }
                //       }
                //       if (record.orderType == "3") {
                //         if (record.orderStatus == '1') {
                //             return <a href={`#/order/${record.id}/partnersDetail1/${record.code}/${record.orderStatus}`}>{text}</a>;
                //           } else {
                //             return <a href={`#/order/${record.id}/partnersDetail/${record.code}`}>{text}</a>;
                //         }
                //       }
                //   }
                // },
                //   {
                //       title: '购货单位',
                //       dataIndex: 'buyCompany'
                //   },
                {
                    title: '订单编号',
                    dataIndex: 'ORDER_NUMBER'
                },
                {
                    title: '订单类型',
                    dataIndex: 'ORDER_TYPE_NAME'
                },
                {
                    title: '登记日期',
                    dataIndex: 'BOOKED_DATE',
                    render: text => text ? new Date(text).format('yyyy-MM-dd') : ''
                },
                {
                    title: '购货单位',
                    dataIndex: 'SALES_UNIT_NAME'
                },
                {
                    title: '终端单位',
                    dataIndex: 'ATTRIBUTE11'
                },
                {
                    title: '盘厂客户',
                    dataIndex: 'PC_CUST'
                },
                {
                    title: '业务员',
                    dataIndex: 'USERNAME'
                },
                // {
                //     title: '渠道',
                //     dataIndex: 'SALES_CHANNEL'
                // },
                {
                    title: '物料编码',
                    dataIndex: 'ITEM_NUM',
                    width: 120
                },
                {
                    title: '物料描述',
                    dataIndex: 'DESCRIPTION'
                },
                {
                    title: '欠货数量',
                    dataIndex: 'ORDERED_QUANTITY'
                },
                {
                    title: '牌价',
                    dataIndex: 'UNIT_LIST_PRICE',
                    render: (text, record, index) => {
                        if (userData.roleCode == 'CUSTOMER_INQUIRY') {
                            return (<span>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '单价',
                    dataIndex: 'UNIT_SELLING_PRICE',
                    render: (text, record, index) => {
                        if (userData.roleCode == 'CUSTOMER_INQUIRY') {
                            return (<span>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },
                {
                    title: '销售金额',
                    dataIndex: 'SUM_PRICE',
                    render: (text, record, index) => {
                        if (userData.roleCode == 'CUSTOMER_INQUIRY') {
                            return (<span>{'***'}</span>);
                        } else {
                            return (<span>{text}</span>);
                        }
                    },
                },

                {
                    title: '预计生产周期',
                    dataIndex: 'ATTRIBUTE2'
                },
                {
                    title: '状态',
                    dataIndex: 'LINE_STATUS'
                },
                {
                    title: '头备注',
                    dataIndex: 'ATTRIBUTE5'
                },
                {
                    title: '行备注',
                    dataIndex: 'ATTRIBUTE12'
                },
                {
                    title: '锁库数量',
                    dataIndex: 'LOCKED_QUANTITY'
                },
                {
                    title: '预计到货期',
                    dataIndex: 'CYCLE_DATE'
                },
                //   {
                //       title: '渠道',
                //       dataIndex: 'channel'
                //   },
                //   {
                //       title: '订单类型',
                //       dataIndex: 'orderType',
                //       render: (text, record, index) => {
                //           if (text === "1") return '常规订单';
                //           if (text === "2") return '项目订单';
                //           if (text === "3") return '合作伙伴订单';
                //           return '';
                //       }
                //   },
                //   {
                //       title: '产品线',
                //       dataIndex: 'proLine',

                //   },
                //   {
                //   title: '登记日期',
                //   dataIndex: 'createdDate',
                //   render: text => <span>{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>
                // },
                //   {
                //   title: '销售金额(元)',
                //   dataIndex: 'realityAmount',
                //   render: (text,record,index) => {
                //     // console.log(record.productList[0].terminalUnitPrice)
                //     // // debugger
                //     //      let x = record.productList[0].terminalUnitPrice;
                //    return <span style={{ color: '#d61518' }}>{'¥' + formatMoney(text)}</span>
                //   }
                // },
                //   /*{
                //       title: '销售金额考核',
                //       dataIndex: 'name0',
                //   },
                //   {
                //       title: '币种',
                //       dataIndex: 'name1',
                //   },*/
                //   {
                //       title: '订单状态',
                //       dataIndex: 'orderStatus',
                //       render: (text, record, index) => {
                //           if (text === 1) return '暂存';
                //           if (text === 2) return '待客户确认';
                //           if (text === 3) return '已提交';
                //           if (text === 4) return '已驳回';
                //           if (text === 5) return '驳回后提交';
                //           if (text === 6) return '待收货';
                //           if (text === 7) return '已完成';
                //           if (text === 8) return '客户已驳回';
                //           if (text === 9) return '已确认';
                //           if (text === 10) return '大客户已确认';
                //           return '';
                //       }
                // },
                //   {
                //   title: '订单编号',
                //   dataIndex: 'code'
                // },
                //   {
                //       title: '备注',
                //       dataIndex: 'remark'
                //   },{
                //       title: '操作',
                //       dataIndex: 'action',
                //       render: (text, record, index) => {
                //           // if (record.orderStatus == 1)
                //           //     return <Button size={'small'} onClick={self.auditRecord.bind(self, index)}>审核</Button>;
                //           // if (record.orderStatus == 3)
                //           //     return <Button size={'small'} onClick={self.confirmRecord.bind(self, index)}>确认收货</Button>;

                //           // if (record.orderStatus == 4)
                //           //     return <Button size={'small'} onClick={self.evaluationRecord.bind(self, index)}>评价</Button>;
                //           if (record.orderStatus == 1)
                //             return (<div>
                //               <Button size={'small'} style={{float:'left'}} onClick={self.editRecord.bind(self,record, index)}>编辑</Button>
                //               <Button size={'small'} style={{float:'left'}} onClick={self.deleteRecord.bind(self, index)}>删除</Button>
                //             </div>)
                //       }
                //   }
            ],
            rows
        };
        let self = this;
        let backHide = (customerManagementId) => {
            if (customerManagementId) {
                return <Button onClick={self.backTo.bind(self)}>返回</Button>
            } else {
                return '';
            }
        }
        return <div>
            <DmsTab options={opts} defaultKey={0}>
                {backHide(this.customerManagementId)}
            </DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <p>汇总金额：{all_sum_price} </p>
                <div className="dms-table-head" style={{padding: '8px 8px 8px 0'}}>
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange}>导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>
        </div>
    }
}

//使用高阶组件withRouter来封装OrderList。目的是将router对象暴露出来
export default withRouter(SearchOwning);



// WEBPACK FOOTER //
// ./src/routes/searchOwning/list.js